export const baseEnvironment = {
    apiUrl: 'http://prd-wts-alb-713162059.ap-northeast-1.elb.amazonaws.com/api',
    urlDevicePrint: 'http://localhost:8080/Format/Print',
    formatArchiveUrl: 'https://prod-wts-web.s3.ap-northeast-1.amazonaws.com/',
    urlFormatContainer: 'returnable_label_with_comp.spfmtz',
    urlFormatUser: 'user_label.spfmtz',
    formatIdNumber: 1,
};
